import { gql } from '@apollo/client';

const INIT_RESOURCE_VERSION_PREVIEW = gql`
  mutation InitResourceVersionPreview($resourceId: ID!, $versionNumber: Int!) {
    initResourceVersionPreview(
      resourceId: $resourceId
      versionNumber: $versionNumber
    )
  }
`;

export default INIT_RESOURCE_VERSION_PREVIEW;
